import { ChangeDetectorRef, Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AuthLog } from '../../../model/analysis-details.model';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { DBService } from '../../../service/DB.service';
import { Subscription } from 'rxjs';
import { StorageService } from '../../../service/storage.service';

@Component({
  selector: 'app-auth-log',
  templateUrl: './auth-log.component.html',
  styleUrls: ['./auth-log.component.scss']
})

export class AuthLogComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: false }) paginator?: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort?: MatSort;
  dataSource?: MatTableDataSource<AuthLog>;
  tableColumns: string[] = ['userId', 'activityDate', 'eventResponse'];
  @ViewChild(MatPaginator, { static: false }) ch_paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) ch_sort!: MatSort;
  logdata: AuthLog[] = [];
  temp_analysisData: any;
  authLogs: AuthLog[] = [];
  signedInUser: any;
  loading = false;
  LogstartDate: string | undefined;
  LogendDate: string | undefined;
  userID!: string;
  showTable = false;
  userAttributes?: string | null;
  illegalUser?: boolean;
  private authlogDataSubscription?: Subscription;
  private currentLoginUser?: Subscription;
  maxDate = new Date();
  loginuserId!: string;
  displayErrorMessage: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = ''

  constructor(
    private dbService: DBService,
    private ref: ChangeDetectorRef,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    this.userAttributes = this.storageService.get('access');
    this.loginuserId = this.storageService.get('userId') ?? '';
    if (this.userAttributes === 'PI' || this.userAttributes === 'QA') {
      this.illegalUser = true;
    }
    else if (this.userAttributes === 'GA' || this.userAttributes === 'SU') {
      this.illegalUser = false;
      this.getAuthLoginData(this.loginuserId, this.loginuserId, this.LogstartDate, this.LogendDate);
    }
  }

  getAuthLoginData(loginuserId, loginuserid, LogstartDate, LogendDate) {
    this.errorMessage = '';
    this.isLoading = true;
    this.showTable = false;
    this.dbService.getAuthData(loginuserId, loginuserid, LogstartDate, LogendDate);
    this.authlogDataSubscription = this.dbService.authLogs.subscribe({
      next: (data: AuthLog[]) => {
        this.isLoading = false;
        if (data && data.length) {
          this.showTable = true;
          this.displayErrorMessage = false;
          this.dataSource = new MatTableDataSource(data);
          this.ref.detectChanges();
          this.dataSource.paginator = this.paginator ?? null;
        }
        else {
          this.showTable = false;
          this.displayErrorMessage = true;
          this.errorMessage = "User Not Found";
        }
      },
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource!.filter = filterValue.trim().toLowerCase();
  }

  openPDF() {
    const DATA: any = document.getElementById('authData');
    html2canvas(DATA).then((canvas) => {
      const fileWidth = 208;
      const fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      const PDF = new jsPDF('p', 'mm', 'a4');
      const position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save('Login-Report.pdf');
    });
  }


  selectedLogDates(dateRangeStart: { value: string | undefined; }, dateRangeEnd: { value: string | undefined; }, UserID: { value: string }) {
    this.displayErrorMessage = false;
    this.errorMessage = '';
    this.LogstartDate = dateRangeStart.value;
    this.LogendDate = dateRangeEnd.value;
    this.userID = UserID.value;
    this.getAuthLoginData(this.loginuserId, this.userID, this.LogstartDate, this.LogendDate);

  }

  ngOnDestroy() {
    // Unsubscribe from the observable to avoid memory leaks
    if (this.authlogDataSubscription) {
      this.authlogDataSubscription.unsubscribe();
    }
    if (this.currentLoginUser) {
      this.currentLoginUser.unsubscribe();
    }
  }

}
